/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */

window.PXUTheme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.showDrawer();

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      let dataForm = {};
      $addToCartForm.find ('[data-variant-option], input, select').each(function() {
        if ($(this).attr('data-option-name') !== undefined) {
          dataForm[$(this).attr('data-option-name').toLowerCase()] = $(this).attr('data-variant-option-chosen-value');
        } else {
          dataForm[this.name] = $(this).val();
        }

      });
      window.PXUTheme.jsAjaxCart.addToCart($addToCartForm, dataForm);

      return false;
    });

    $(document).on('click', '.purchase-details__buttons:has(.disabled)', function (e) {
      const sizeSelector = $(this).closest('form').find('.custom-dropdown-selected');
      // change border, open dropdown
      setTimeout(() => {      
        $(sizeSelector).css('border', '2px solid black');
        $(sizeSelector)[0].click();
      }, 100);
    });


    if (!window.PXUTheme.jsAjaxCart.ajaxCartControlsHandlerBound) {
      document.addEventListener('pointerdown', function (e) {
        const quantityControl = e.target.closest('[data-update-quantity]');
        if (!quantityControl || !quantityControl.closest('[data-ajax-cart-content]')) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        quantityControl.setAttribute('data-pointer-handled', 'true');
        window.PXUTheme.jsAjaxCart.updateQuantityFromControl(quantityControl);
      }, true);

      document.addEventListener('click', function (e) {
        const quantityControl = e.target.closest('[data-update-quantity]');
        if (quantityControl && quantityControl.closest('[data-ajax-cart-content]')) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          if (quantityControl.getAttribute('data-pointer-handled') === 'true') {
            quantityControl.removeAttribute('data-pointer-handled');
            return;
          }

          window.PXUTheme.jsAjaxCart.updateQuantityFromControl(quantityControl);
          return;
        }

        const deleteButton = e.target.closest('[data-ajax-cart-delete]');
        if (!deleteButton || !deleteButton.closest('[data-ajax-cart-content]')) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (deleteButton.getAttribute('data-removing') === 'true') return;
        deleteButton.setAttribute('data-removing', 'true');

        const cartLine = deleteButton.closest('[data-line-item]') || deleteButton.closest('.ajax-cart__product');
        const lineItemKey = deleteButton.getAttribute('data-cart-item-key')
          || (cartLine ? cartLine.getAttribute('data-line-item-key') : null)
          || (cartLine ? cartLine.getAttribute('data-cart-item') : null)
          || window.PXUTheme.jsAjaxCart.getLineItemKey(deleteButton);

        if (!lineItemKey) {
          deleteButton.removeAttribute('data-removing');
          return;
        }

        if (cartLine) cartLine.setAttribute('data-removing', 'true');
        if (cartLine) {
          var input = cartLine.querySelector('.quantity-input');
          if (input) input.value = 0;
          if (window.PXUTheme.updateCartTotals) window.PXUTheme.updateCartTotals(cartLine);
          cartLine.remove();
        }
        if (window.PXUTheme.jsAjaxCart.quantityUpdateState) {
          var qs = window.PXUTheme.jsAjaxCart.quantityUpdateState[String(lineItemKey)];
          if (qs) { clearTimeout(qs.timer); clearTimeout(qs.refreshTimer); }
          delete window.PXUTheme.jsAjaxCart.quantityUpdateState[String(lineItemKey)];
        }

        window.PXUTheme.jsAjaxCart.changeCartLine(lineItemKey, 0, function(cart) {
          window.PXUTheme.jsAjaxCart.updateView();
          if (typeof window.PXUTheme.jsCart !== 'undefined') {
            window.PXUTheme.jsCart.updateView(cart, lineItemKey);
          }
        }, function() {
          window.PXUTheme.jsAjaxCart.updateView();
        });
      }, true);

      const handleQuantityInput = function (e) {
        const quantityInput = e.target.closest('.quantity-input');
        if (!quantityInput || !quantityInput.closest('[data-ajax-cart-content]')) return;
        if (quantityInput.value === '') return;

        e.stopPropagation();
        e.stopImmediatePropagation();

        window.PXUTheme.jsAjaxCart.updateQuantityFromInput(quantityInput);
      };

      document.addEventListener('input', handleQuantityInput, true);
      document.addEventListener('change', handleQuantityInput, true);
      document.addEventListener('keyup', handleQuantityInput, true);
      document.addEventListener('mouseup', handleQuantityInput, true);
      document.addEventListener('pointerup', handleQuantityInput, true);

      window.PXUTheme.jsAjaxCart.ajaxCartControlsHandlerBound = true;
    }

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsAjaxCart.hideDrawer();
      window.PXUTheme.jsAjaxCart.hideMiniCart();

      return false;
    });

  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      $el.addClass('show-mini-cart');
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    document.documentElement.classList.add('scroll-locked');
    document.body.setAttribute('data-scroll-position', scrollTop);
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollTop + 'px';
    document.body.style.width = '100%';
    this.ajaxCartDrawer.css('overscroll-behavior', 'contain');

    $('.ajax-cart__overlay').on('touchmove.drawerLock', function (e) {
      e.preventDefault();
    });

    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;

    var scrollTop = document.body.getAttribute('data-scroll-position') || 0;
    document.documentElement.classList.remove('scroll-locked');
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.removeAttribute('data-scroll-position');
    this.ajaxCartDrawer.css('overscroll-behavior', '');
    $('.ajax-cart__overlay').off('touchmove.drawerLock');

    window.scrollTo(0, parseInt(scrollTop || '0'));

    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  getCartItems: function (callback) {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
        callback(cart.items);
      },
      error: function(XMLHttpRequest, textStatus) {
        console.error("Error retrieving mini cart contents");
      }
    });
  },
  loadAjaxCartView: function () {
    const $deferred = $.Deferred();
    const cartUrl = window.PXUTheme.routes.cart_url;
    const separator = cartUrl.indexOf('?') > -1 ? '&' : '?';

    $.ajax({
      url: cartUrl + separator + 'view=ajax&_=' + Date.now(),
      cache: false,
      dataType: 'html',
      headers: {
        'cache-control': 'no-cache'
      },
      success: function (response) {
        const el = document.createElement('div');
        el.innerHTML = response;

        const optionsEl = el.querySelector('[data-options]');
        const responseOptions = optionsEl ? JSON.parse(optionsEl.innerHTML) : {};
        const htmls = el.querySelectorAll('[data-html]');
        let html = {};

        if (htmls.length === 1 && htmls[0].getAttribute('data-html') === '') {
          html = htmls[0].innerHTML;
        } else {
          for (let i = 0; i < htmls.length; i++) {
            html[htmls[i].getAttribute('data-html')] = htmls[i].innerHTML;
          }
        }

        if (!html.content) {
          const cartContent = el.querySelector('[data-ajax-cart-content]');
          if (cartContent) {
            html.content = cartContent.innerHTML;
          }
        }

        $deferred.resolve({
          options: responseOptions,
          html: html
        });
      },
      error: function () {
        $deferred.reject();
      }
    });

    return $deferred.promise();
  },
  getLineItemKey: function (element) {
    const el = element && element.jquery ? element[0] : element;
    const lineItem = el ? el.closest('[data-line-item]') : null;
    const href = el ? el.getAttribute('href') : null;
    let hrefKey = null;

    if (href) {
      try {
        hrefKey = new URL(href, window.location.origin).searchParams.get('id');
      } catch (error) {
        hrefKey = null;
      }
    }

    return lineItem?.getAttribute('data-line-item')
      || lineItem?.getAttribute('data-line-item-key')
      || el?.getAttribute('data-cart-item-key')
      || lineItem?.getAttribute('data-cart-item')
      || hrefKey
      || null;
  },
  updateQuantityFromControl: function (control) {
    if (!control || control.hasAttribute('disabled')) return;

    const quantityBox = control.closest('.product-quantity-box');
    const input = quantityBox ? quantityBox.querySelector('.quantity-input') : null;
    const lineItemKey = this.getLineItemKey(control);

    if (!quantityBox || !input || !lineItemKey) return;
    if (quantityBox.getAttribute('data-removing') === 'true' || control.closest('[data-removing="true"]')) return;

    let quantity = parseInt(input.value, 10);
    if (Number.isNaN(quantity)) quantity = 0;

    if (control.getAttribute('data-update-quantity') === 'plus') {
      quantity += 1;
    } else if (control.getAttribute('data-update-quantity') === 'minus') {
      quantity = quantity <= 1 ? 0 : quantity - 1;
    }

    const maxQuantity = parseInt(input.getAttribute('max'), 10);
    if (Number.isInteger(maxQuantity)) quantity = Math.min(quantity, maxQuantity);
    input.value = Math.max(quantity, 0);
    this.updateDrawerQuantityControls(quantityBox);
    if (window.PXUTheme.updateCartTotals) window.PXUTheme.updateCartTotals(quantityBox);
    this.updateDrawerLineQuantity(lineItemKey, quantity, quantityBox);
  },
  updateQuantityFromInput: function (input) {
    const quantityBox = input.closest('.product-quantity-box');
    const lineItemKey = this.getLineItemKey(input);

    if (!quantityBox || !lineItemKey) return;
    if (quantityBox.getAttribute('data-removing') === 'true' || input.closest('[data-removing="true"]')) return;

    let quantity = parseInt(input.value, 10);
    if (Number.isNaN(quantity) || quantity < 0) quantity = 0;

    const maxQuantity = parseInt(input.getAttribute('max'), 10);
    if (Number.isInteger(maxQuantity)) quantity = Math.min(quantity, maxQuantity);
    input.value = quantity;
    this.updateDrawerQuantityControls(quantityBox);
    if (window.PXUTheme.updateCartTotals) window.PXUTheme.updateCartTotals(quantityBox);
    this.updateDrawerLineQuantity(lineItemKey, quantity, quantityBox);
  },
  updateDrawerQuantityControls: function (quantityBox) {
    const input = quantityBox ? quantityBox.querySelector('.quantity-input') : null;
    const minus = quantityBox ? quantityBox.querySelector('[data-update-quantity="minus"]') : null;
    const plus = quantityBox ? quantityBox.querySelector('[data-update-quantity="plus"]') : null;
    const quantity = input ? parseInt(input.value, 10) : 0;

    if (quantityBox && quantity <= 0) {
      quantityBox.setAttribute('data-removing', 'true');
    }

    if (input) {
      input.disabled = quantity <= 0;
    }

    if (minus) {
      if (quantity <= 1) {
        minus.setAttribute('disabled', 'disabled');
      } else {
        minus.removeAttribute('disabled');
      }
    }

    if (plus) {
      const maxQuantity = input && input.hasAttribute('max') ? parseInt(input.getAttribute('max'), 10) : null;
      if (quantity <= 0 || (Number.isInteger(maxQuantity) && quantity >= maxQuantity)) {
        plus.setAttribute('disabled', 'disabled');
      } else {
        plus.removeAttribute('disabled');
      }
    }
  },
  hasActiveQuantityUpdates: function () {
    const states = this.quantityUpdateState || {};

    for (const key in states) {
      if (Object.prototype.hasOwnProperty.call(states, key)) {
        return true;
      }
    }

    return false;
  },
  updateDrawerLineQuantity: function (lineItemKey, quantity, quantityBox) {
    const stateKey = String(lineItemKey);
    this.quantityUpdateState = this.quantityUpdateState || {};
    this.quantityUpdateState[stateKey] = this.quantityUpdateState[stateKey] || {};

    const state = this.quantityUpdateState[stateKey];
    clearTimeout(state.refreshTimer);
    state.quantity = Math.max(quantity, 0);
    state.quantityBox = quantityBox;

    clearTimeout(state.timer);
    state.timer = setTimeout(function() {
      window.PXUTheme.jsAjaxCart.flushDrawerLineQuantity(stateKey);
    }, 120);
  },
  flushDrawerLineQuantity: function (lineItemKey) {
    const state = this.quantityUpdateState && this.quantityUpdateState[String(lineItemKey)];
    if (!state) return;

    if (state.inFlight) {
      state.needsFlush = true;
      return;
    }

    state.inFlight = true;
    state.needsFlush = false;

    const quantity = state.quantity;
    if (state.quantityBox) {
      state.quantityBox.setAttribute('data-updating', 'true');
    }

    this.changeCartLine(lineItemKey, quantity, function(cart) {
      state.inFlight = false;

      if (state.quantityBox) {
        state.quantityBox.removeAttribute('data-updating');
      }

      if (state.needsFlush || state.quantity !== quantity) {
        window.PXUTheme.jsAjaxCart.flushDrawerLineQuantity(lineItemKey);
        return;
      }

      if (quantity <= 0 && state.quantityBox) {
        const line = state.quantityBox.closest('.ajax-cart__product');
        if (line) line.remove();
      }

      if (window.PXUTheme.updateCartTotalsFromCart) {
        window.PXUTheme.updateCartTotalsFromCart(cart, state.quantityBox);
      }

      clearTimeout(state.refreshTimer);
      state.refreshTimer = setTimeout(function() {
        const currentState = window.PXUTheme.jsAjaxCart.quantityUpdateState[String(lineItemKey)];
        if (!currentState || currentState.inFlight || currentState.needsFlush || currentState.quantity !== quantity) return;

        delete window.PXUTheme.jsAjaxCart.quantityUpdateState[String(lineItemKey)];
        window.PXUTheme.refreshProductQuantityLimits()
          .catch(function () {})
          .then(function () {
            window.PXUTheme.jsAjaxCart.updateView();
          });
      }, 180);
    }, function() {
      state.inFlight = false;

      if (state.quantityBox) {
        state.quantityBox.removeAttribute('data-updating');
        state.quantityBox.removeAttribute('data-removing');
      }

      delete window.PXUTheme.jsAjaxCart.quantityUpdateState[String(lineItemKey)];
      window.PXUTheme.jsAjaxCart.updateView();
    });
  },
  changeCartLine: function (lineItemKey, quantity, success, error) {
    const changeData = String(lineItemKey).indexOf(':') > -1
      ? { quantity: quantity, id: lineItemKey }
      : { quantity: quantity, line: lineItemKey };

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: changeData,
      dataType: 'json',
      success: function(cart) {
        window.PXUTheme.syncCartPersonalizations(cart).then(function(synchronizedCart) {
          if (success) success(synchronizedCart);
        }).catch(function() {
          if (error) error();
        });
      },
      error: function (XMLHttpRequest, textStatus) {
        if (error) error(XMLHttpRequest, textStatus);
      }
    });
  },
  bindAjaxCartControls: function ($container) {
    const $scope = $container && $container.length ? $container : $('[data-ajax-cart-content]');

    $scope.find('[data-ajax-cart-delete], [data-update-quantity], .quantity-input')
      .off('.ajaxCartControls');
  },
  removeFromCart: function (lineItemKey, callback) {
    this.changeCartLine(lineItemKey, 0, callback);
  },
  removeItemFromCart: function (lineItemKey, callback) {
    this.removeFromCart(lineItemKey, function() {
      window.PXUTheme.jsAjaxCart.updateView();
      if (typeof window.PXUTheme.jsCart !== 'undefined') {
        window.PXUTheme.jsCart.updateView();
      }
      if (callback) callback();
    });
  },
  initializeAjaxCart: function () {

    window.PXUTheme.jsAjaxCart.loadAjaxCartView()
      .done(({ html, options }) => {

        const $cartContent = $('[data-ajax-cart-content]');
        $cartContent.html(html.content);
        window.PXUTheme.jsAjaxCart.bindAjaxCartControls($cartContent);

        // Converting the currencies
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    window.PXUTheme.jsAjaxCart.loadAjaxCartView()
      .done(({ html, options }) => {

        const $cartContent = $('.mobile-header [data-ajax-cart-content]');
        $cartContent.html(html.content);
        window.PXUTheme.jsAjaxCart.bindAjaxCartControls($cartContent);

      })
      .fail(() => {
        // some error handling
      });
  },
  addToCart: function ($addToCartForm, dataForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');

    if (this.recipientForm) {
      this.recipientForm.classList.remove('recipient-form--has-errors');
    }

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      let productsData;
      function getSelectedVariantId() {
        const selectedVariantOption = document.querySelector('.custom-dropdown li[data-variant-id].selected');
        if (selectedVariantOption) return selectedVariantOption.getAttribute('data-variant-id');

        const variantSelectionId = $addToCartForm.closest('.product_form').find('variant-selection').attr('variant');
        if (variantSelectionId && variantSelectionId !== 'not-selected' && variantSelectionId !== 'unavailable') return String(variantSelectionId);

        const formVariantId = $addToCartForm.find('[name="id"]').last().val();
        if (formVariantId && formVariantId !== 'not-selected') return String(formVariantId);

        if (dataForm && dataForm.id && dataForm.id !== 'not-selected') return String(dataForm.id);

        return null;
      }

      function getSellingPlanFromThemeData(variantId, selectedPlanIndex) {
        if (!variantId || !Number.isInteger(selectedPlanIndex)) return null;

        const sellingPlanJson = document.querySelector('[data-acc-subscription-selling-plans]');
        if (!sellingPlanJson) return null;

        try {
          const sellingPlanMap = JSON.parse(sellingPlanJson.textContent || '{}');
          const sellingPlans = sellingPlanMap[String(variantId)] || [];
          return sellingPlans[selectedPlanIndex - 1] || null;
        } catch (error) {
          console.warn('[subs] selling plan map parse failed', error);
        }

        return null;
      }

      function getSelectedSellingPlan() {
        const subscriptionUi = document.querySelector('.acc.acc-subscription');
        const selectedSubscriptionUi = subscriptionUi ? subscriptionUi.querySelector('.sub-ui-radio:checked') : null;
        const accSellingPlanInput = $addToCartForm.find('[name="selling_plan"][data-acc-selling-plan]:not(:disabled)').last().val();

        if (subscriptionUi && accSellingPlanInput) {
          return accSellingPlanInput;
        }

        if (subscriptionUi && subscriptionUi.dataset.selectedSellingPlan) {
          return subscriptionUi.dataset.selectedSellingPlan;
        }

        if (subscriptionUi && !selectedSubscriptionUi) {
          return null;
        }

        const selectedPlanIndex = selectedSubscriptionUi
          ? Number(selectedSubscriptionUi.dataset.target)
          : Number(subscriptionUi?.dataset.selectedSubIndex);
        const expectedVariantId = getSelectedVariantId();
        const sellingPlanFromThemeData = getSellingPlanFromThemeData(expectedVariantId, selectedPlanIndex);

        if (sellingPlanFromThemeData) {
          return sellingPlanFromThemeData;
        }

        const appContainer = document.querySelector('.shopify_subscriptions_app_container');
        let appBlock = null;

        if (appContainer && selectedSubscriptionUi && expectedVariantId) {
          appBlock = appContainer.querySelector(`.shopify_subscriptions_app_block[data-variant-id="${expectedVariantId}"]`);
        }

        if (!appBlock && appContainer) {
          appBlock = appContainer.querySelector('.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)');
        }

        if (appBlock) {
          if (Number.isInteger(selectedPlanIndex)) {
            const selectedPlanRadio = appBlock.querySelectorAll('input[name="selling_plan"]')[selectedPlanIndex];
            if (selectedPlanRadio && selectedPlanRadio.value && !selectedPlanRadio.disabled) {
              return selectedPlanRadio.value;
            }
          }

          const checkedRadio = appBlock.querySelector('input[name="selling_plan"]:checked');
          if (checkedRadio && checkedRadio.value && !checkedRadio.disabled) {
            return checkedRadio.value;
          }

          const hiddenOrSelectPlan = appBlock.querySelector('input[name="selling_plan"][type="hidden"]:not(:disabled), select[name="selling_plan"]:not(:disabled)');
          if (hiddenOrSelectPlan && hiddenOrSelectPlan.value) {
            return hiddenOrSelectPlan.value;
          }
        }

        if (subscriptionUi) {
          return null;
        }

        const usableSellingPlanField = function() {
          return $(this).val() && !$(this).prop('disabled') && !$(this).closest('.shopify_subscriptions_app_block--hidden').length;
        };

        return $addToCartForm.find('[name="selling_plan"]:checked').filter(usableSellingPlanField).last().val()
          || $addToCartForm.find('[name="selling_plan"][type="hidden"], select[name="selling_plan"]').filter(usableSellingPlanField).last().val()
          || null;
      }

      const selectedVariantId = getSelectedVariantId();
      if (selectedVariantId) {
        dataForm.id = selectedVariantId;
      }

      let sellingPlan = getSelectedSellingPlan();

      function applySellingPlan(productData) {
        if (sellingPlan) {
          productData.selling_plan = sellingPlan;
        }

        return productData;
      }

      if(document.querySelector('#selected-initials') && document.querySelector('#selected-initials')?.textContent !== "") {
        const placementInput = document.querySelector('[name="attributes[Platzierung]"]');
        const symbolInput = document.querySelector('[name="attributes[Symbol]"]');
        const colorInput = document.querySelector('[name="attributes[Fadenfarbe]"]');

        let selectedPos = placementInput.value;
        var selectedSymbol = symbolInput.value;

        var selectedColor = colorInput.value;

        let OptionObj = {};
        if(document.querySelector('[name="attributes[Initialen]"]').value !== '') {
          let initials = $('[name="attributes[Initialen]"]').val().toUpperCase();

          const fontInput = document.querySelector('[name="attributes[Schriftart]"]');
          let selectedFont = fontInput.value;

          OptionObj[dataForm.firstOptionName] = initials;
          OptionObj[dataForm.secondOptionName] = selectedFont;
        }
        OptionObj[dataForm.symbolOptionName] = selectedSymbol;
        OptionObj[dataForm.thirdOptionName] = selectedColor;
        OptionObj[dataForm.fourOptionName] = selectedPos;
        OptionObj[dataForm.forOptionName] = dataForm.sku;


        let productSecondData = {
          id: '49091173384488',
          quantity: dataForm.quantity,
          properties: OptionObj
        };
        if(dataForm.gift_wrapping === 'yes'){
          let checkboxGiftInput = document.querySelector('#gift-wrapping').getAttribute('data_gift_id');
          let productFirstData = {
            id: dataForm.id,
            quantity: dataForm.quantity
          };
          applySellingPlan(productFirstData);

          let productThirdData = {
            id: checkboxGiftInput,
            quantity: dataForm.quantity,
            properties: {
              For: dataForm.sku
            }
          };
          productsData = { items:[productThirdData, productSecondData, productFirstData]};
        } else {
          let productFirstData = {
            id: dataForm.id,
            quantity: dataForm.quantity
          };
          applySellingPlan(productFirstData);
          productsData = { items:[productSecondData, productFirstData]};
        }
      } else {
        if(dataForm.gift_wrapping === 'yes'){
          let checkboxGiftInput = document.querySelector('#gift-wrapping').getAttribute('data_gift_id');
          let productFirstData = {
            id: dataForm.id,
            quantity: dataForm.quantity
          };
          applySellingPlan(productFirstData);
          let productSecondData = {
            id: checkboxGiftInput,
            quantity: dataForm.quantity,
            properties: {
              For: dataForm.sku
            }
          };
          productsData = { items:[productSecondData, productFirstData]};
        } else {
          const serializedForm = $addToCartForm.serializeArray().filter(function(field) {
            return field.name !== 'selling_plan';
          });
          const selectedVariantId = getSelectedVariantId();

          if (selectedVariantId) {
            const idField = serializedForm.find(function(field) {
              return field.name === 'id';
            });

            if (idField) {
              idField.value = selectedVariantId;
            } else {
              serializedForm.push({ name: 'id', value: selectedVariantId });
            }
          }

          if (sellingPlan) {
            serializedForm.push({ name: 'selling_plan', value: sellingPlan });
          }

          productsData = $.param(serializedForm);
        }

      }


      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: productsData,
        beforeSend: function () {
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {
          let $el = $('[data-ajax-cart-trigger]');

          window.PXUTheme.refreshProductQuantityLimits().catch(function () {});

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          function addedToCart() {

            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              window.PXUTheme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

            $el.addClass('show-mini-cart');

            $addToCartBtn.find('span')
              .removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            if ($addToCartBtn.attr('data-inventory-limit-reached') !== 'true') {
              $addToCartBtn
                .removeAttr('disabled')
                .removeClass('disabled');
            }

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          const cartViewUpdate = window.PXUTheme.jsAjaxCart.updateView();
          if (cartViewUpdate && cartViewUpdate.done) {
            cartViewUpdate.done(function() {
              window.PXUTheme.jsAjaxCart.showDrawer();
            });
          } else {
            window.PXUTheme.jsAjaxCart.showDrawer();
          }

          if (window.PXUTheme.jsCart) {
            $.ajax({
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);
              }
            });
          }

        },
        error: XMLHttpRequest => {
          const response = eval('(' + XMLHttpRequest.responseText + ')');

          $('.warning').remove();

          let cartWarning;

          if (response.errors && response.errors.email) {
            this.recipientForm.classList.add('recipient-form--has-errors');
          } else {
            cartWarning = `<p class="cart-warning__message animated bounceIn">${response.description.replace('All 1 ', 'All ')}</p>`;
          }

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },
  updateView: function () {
    if (window.PXUTheme.jsAjaxCart.hasActiveQuantityUpdates()) {
      window.PXUTheme.jsAjaxCart.pendingViewRefresh = true;
      return $.Deferred().resolve().promise();
    }

    const requestId = (window.PXUTheme.jsAjaxCart.viewRequestId || 0) + 1;
    window.PXUTheme.jsAjaxCart.viewRequestId = requestId;

    return window.PXUTheme.jsAjaxCart.loadAjaxCartView()
    .done(({ html, options }) => {
      if (requestId !== window.PXUTheme.jsAjaxCart.viewRequestId) return;

      if (window.PXUTheme.jsAjaxCart.hasActiveQuantityUpdates()) {
        window.PXUTheme.jsAjaxCart.pendingViewRefresh = true;
        return;
      }

      window.PXUTheme.jsAjaxCart.pendingViewRefresh = false;

      const $cartContent = $('[data-ajax-cart-content]');
      if (html.content) {
        $cartContent.html(html.content);
        window.PXUTheme.jsAjaxCart.bindAjaxCartControls($cartContent);
      }

      if (options.item_count > 0) {
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('.action-area__link').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
      } else {
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('.action-area__link').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}

/******/ })()
;
